import { DepositSliceState } from 'src/core/models'

const depositsState: DepositSliceState = {
  list: {
    loading: false,
    error: null,
    deposits: [],
    filteredDeposits: [],
    selectedDeposits: [],
    filterText: null,
    removeDeposits: {
      loading: false,
      success: false,
      error: null
    }
  },
  fetchDeposit: {
    loading: false,
    error: null,
    deposit: null
  },
  validateDeposit: {
    loading: false,
    success: false,
    currentDepositId: null
  },
  cancelDeposit: {
    loading: false,
    success: false,
    currentDepositId: null
  }
}

export { depositsState as initialState }
